import { render, staticRenderFns } from "./about-plant.vue?vue&type=template&id=d19af064&scoped=true&"
import script from "./about-plant.vue?vue&type=script&lang=js&"
export * from "./about-plant.vue?vue&type=script&lang=js&"
import style0 from "./about-plant.vue?vue&type=style&index=0&id=d19af064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19af064",
  null
  
)

export default component.exports